import {
  CREATE_BRAND_FAILURE,
  CREATE_BRAND_REQUEST,
  GET_ALL_BRAND_REQUEST,
  GET_ALL_BRAND_SUCCESS,
  GET_ALL_BRAND_FAILURE,
  DELETE_BRAND_REQUEST,
  DELETE_BRAND_FAILURE,
  UPDATE_BRAND_REQUEST,
  UPDATE_BRAND_FAILURE,
  DELETE_BRAND_SUCCESS,
} from "./ActionType";

const initialState = {
  brands: [],
  loading: false,
  error: "",
};

export const brandReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_BRAND_REQUEST:
      return { ...state, loading: true };

    case CREATE_BRAND_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_BRAND_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_BRAND_SUCCESS:
      return { ...state, loading: false, error: "", brands: action.payload };

    case GET_ALL_BRAND_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_BRAND_REQUEST:
      return { ...state, loading: true };

    case DELETE_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        brands: state.brands?.response?.filter(brnd => brnd.id !== action.payload)  // Remove deleted category
      };

    case DELETE_BRAND_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_BRAND_REQUEST:
      return { ...state, loading: true };

    case UPDATE_BRAND_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
